import { ButtonProps, ModalProps, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { CustomModal } from 'components/molecules/PricingSimulator/Modals/ScenarioColumnEditModal';
import { MouseEventHandler, ReactNode } from 'react';
import { BaseButtonProps } from 'antd/lib/button/button';

type PopupProps = {
    open: boolean;
    onCancel: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onClose?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onSubmitClick: () => void;
    loading: boolean;
    description: string | ReactNode;
    title: string;
    okText: ReactNode;
    cancelText?: ReactNode;
    closable?: boolean;
    maskClosable?: boolean;
    subTitle?: string;
    okButtonProps?: ModalProps['okButtonProps'];
    width?: number;
    /**
     * Lands on a wrapper inside the modal body, not on the AntD dialog root —
     * the dialog renders into a portal and does not forward arbitrary attributes.
     * The confirm/cancel buttons derive `${id}_confirm_btn` / `${id}_cancel_btn`.
     */
    'data-testid'?: string;
};
const ConfirmationModal = ({
    open,
    onCancel,
    onClose,
    loading,
    onSubmitClick,
    description,
    okText,
    okButtonProps,
    title,
    subTitle,
    cancelText,
    width = 400,
    closable,
    maskClosable,
    'data-testid': dataTestId,
}: PopupProps) => {
    return (
        <CustomModal
            maskClosable={maskClosable}
            width={width}
            cancelButtonProps={
                {
                    style: { borderRadius: 6 },
                    'data-testid': dataTestId ? `${dataTestId}_cancel_btn` : undefined,
                    onClick: (e) => {
                        if (loading) return;
                        onCancel(e);
                    },
                } as ButtonProps
            }
            onCancel={(e) => {
                if (loading) return;
                (onClose ?? onCancel)(e);
            }}
            onOk={() => {
                if (loading) return;
                onSubmitClick();
            }}
            title={title}
            centered
            closable={closable}
            open={open}
            cancelText={cancelText}
            okButtonProps={
                {
                    ...okButtonProps,
                    'data-testid': dataTestId ? `${dataTestId}_confirm_btn` : undefined,
                } as ButtonProps
            }
            okText={okText}
        >
            <div data-testid={dataTestId}>
                <p className="pl-2">{subTitle}</p>
                {description && (
                    <div className="pl-2 mt-2 text-backgroundGreyAlt7 font-xs">
                        {typeof description === 'string' ? <p>{description}</p> : description}
                    </div>
                )}
            </div>
        </CustomModal>
    );
};
export default ConfirmationModal;
